import React, { useState } from 'react';

import AOS from 'aos';
import PropTypes from 'prop-types';
import { FaDownload } from 'react-icons/fa';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

import { useTranslation } from 'react-i18next';

import polandChecklistPdf from '../../Assets/files/poland-checklist-ua.pdf';
import WithBackground from '../Common/WithBackground';

import './style.css';

const WorkerFaq = ({ bg, overlay }) => {
  const { t } = useTranslation();
  const [expandedItems, setExpandedItems] = useState([]);

  const faqData = [
    {
      id: 1,
      question: t('workerFaq.questions.documents.question'),
      answer: t('workerFaq.questions.documents.answer'),
    },
    {
      id: 2,
      question: t('workerFaq.questions.accommodation.question'),
      answer: t('workerFaq.questions.accommodation.answer'),
    },
    {
      id: 3,
      question: t('workerFaq.questions.residenceCard.question'),
      answer: t('workerFaq.questions.residenceCard.answer'),
    },
    {
      id: 4,
      question: t('workerFaq.questions.couples.question'),
      answer: t('workerFaq.questions.couples.answer'),
    },
    {
      id: 5,
      question: t('workerFaq.questions.workClothing.question'),
      answer: t('workerFaq.questions.workClothing.answer'),
    },
  ];

  const toggleExpanded = (itemId) => {
    setExpandedItems((prev) => {
      const isCurrentlyExpanded = prev.includes(itemId);

      // Refresh AOS after animation completes (both open and close)
      setTimeout(() => {
        AOS.refresh();
      }, 400);

      if (isCurrentlyExpanded) {
        return prev.filter((id) => id !== itemId);
      } else {
        return [...prev, itemId];
      }
    });
  };

  const faqContent = (
    <section className='worker-faq'>
      <div className='worker-faq__container'>
        <div className='worker-faq__header'>
          <h2
            className='worker-faq__title'
            data-aos='fade-up'
            data-aos-delay='100'
            data-aos-once='true'
          >
            {t('workerFaq.title')}
          </h2>
          <p
            className='worker-faq__intro'
            data-aos='fade-up'
            data-aos-delay='200'
            data-aos-once='true'
          >
            {t('workerFaq.intro')}
          </p>
        </div>

        <div className='worker-faq__list'>
          {faqData.map((item) => (
            <div
              key={item.id}
              className={`faq-item ${expandedItems.includes(item.id) ? 'faq-item--expanded' : ''}`}
              data-aos='fade-up'
              data-aos-delay={200}
              data-aos-once='true'
            >
              <button
                className='faq-item__question'
                onClick={() => toggleExpanded(item.id)}
                aria-expanded={expandedItems.includes(item.id)}
              >
                <span className='faq-item__question-text'>{item.question}</span>
                <span className='faq-item__icon'>
                  {expandedItems.includes(item.id) ? (
                    <FiChevronUp />
                  ) : (
                    <FiChevronDown />
                  )}
                </span>
              </button>

              <div className='faq-item__answer'>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div
          className='worker-faq__download'
          data-aos='fade-up'
          data-aos-delay='400'
        >
          <div className='worker-faq__download-content'>
            <h3 className='worker-faq__download-title'>
              {t('workerFaq.checklist.title')}
            </h3>
            <p className='worker-faq__download-description'>
              {t('workerFaq.checklist.description')}
            </p>
            <a
              href={polandChecklistPdf}
              download='Checklist-Poland-OpusAPT.pdf'
              className='worker-faq__download-btn'
            >
              <FaDownload className='worker-faq__download-icon' />
              <span>{t('workerFaq.checklist.downloadButton')}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );

  return bg ? (
    <WithBackground bg={bg} overlay={overlay}>
      {faqContent}
    </WithBackground>
  ) : (
    faqContent
  );
};

WorkerFaq.propTypes = {
  bg: PropTypes.string,
  overlay: PropTypes.oneOf(['dark', 'light', 'golden', 'none']),
};

WorkerFaq.defaultProps = {
  bg: null,
  overlay: 'dark',
};

export default WorkerFaq;
